import {
    useQuery,
    useMutation
} from 'react-query'
import {
    postData,
    getData
} from 'api/request'
import {
    getTransactionUrl,
    getUploadImageUrl,
    getRenewLivenessTokenUrl
} from 'api/api'
import {
    getBase64
} from 'helpers/utils'

const getTransaction = async () => {
    const result = await getData(getTransactionUrl())
    return result
}
const useTransaction = (options = {}) => {
    return useQuery(['getTransaction'], getTransaction, options)
}

const postPassportPhoto = async ({ file, documentType, applicantCountry, countryOfResidence }) => {
    const base64ImageData = await getBase64(file)
    const base64Only = base64ImageData.split(',')[1]
    const imageUrl = await postData(getUploadImageUrl(), {
        passPort: base64Only,
        documentType,
        applicant_country: applicantCountry,
        country_of_residence: countryOfResidence
    })
    return imageUrl
}
const usePassport = () => {
    return useMutation((variables) => postPassportPhoto(variables))
}

const postAddressPhoto = async ({ file, documentType }) => {
    const base64ImageData = await getBase64(file)
    const base64Only = base64ImageData.split(',')[1]
    const imageUrl = await postData(getUploadImageUrl(), {
        correspondenceAddressDocument: base64Only,
        documentType
    })
    return imageUrl
}
const useAddress = () => {
    return useMutation((variables) => postAddressPhoto(variables))
}

const postSignature = async ({ file }) => {
    const imageUrl = await postData(getUploadImageUrl(), {
        eSignature: file,
        documentType: 'png'
    })
    return imageUrl
}
const useSignature = () => {
    return useMutation((variables) => postSignature(variables))
}

const renewLiveness = async ({ file }) => {
    const newtoken = await getData(getRenewLivenessTokenUrl())
    return newtoken
}
const useRenewLiveness = () => {
    return useMutation((variables) => renewLiveness(variables))
}

export {
    useTransaction,
    usePassport,
    useAddress,
    useSignature,
    useRenewLiveness
}